// @ts-nocheck
import { Plugin } from '/home/gitlab-runner/builds/-t7MzySz/0/axinan/fe/agency-vn-web/node_modules/umi/node_modules/@umijs/runtime';

const plugin = new Plugin({
  validKeys: ['modifyClientRenderOpts','patchRoutes','rootContainer','render','onRouteChange','__mfsu','dva','getInitialState','initialStateConfig','request',],
});

export { plugin };
